//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'unison';

import { ThresholdFailedConfirmationModalActions } from '@catalog-ingestion/actions/thresholdFailedConfirmationModalActions';
import {
  PrimaryButton,
  SecondaryButton,
} from '@components/atoms/button/Button';

export const ThresholdFailedConfirmationModal = () => {
  const dispatch = useDispatch();

  const { isOpen } = useSelector(
    (state) => state.catalogIngestionReducers.thresholdFailedConfirmationModal,
  );

  const {
    closeThresholdFailedConfirmationModal: closeModal,
    retryCatalogConnection,
    continueWorkflow,
  } = ThresholdFailedConfirmationModalActions;

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader onCancel={() => dispatch(closeModal())}>
        Are you sure you want to continue?
      </ModalHeader>
      <StyledModalBody>
        With over 10% catalog failure, we recommend that you fix your errors
        before continuing. How would you like to proceed?
      </StyledModalBody>
      <ButtonContainer>
        <CancelButton onClick={() => dispatch(retryCatalogConnection())}>
          Upload Catalog Again
        </CancelButton>
        <PrimaryButton onClick={() => dispatch(continueWorkflow())}>
          Connect Anyway
        </PrimaryButton>
      </ButtonContainer>
    </Modal>
  );
};

const CancelButton = styled(SecondaryButton)`
  && {
    margin-right: ${({ theme }) => theme.spacings['2']};
  }
`;

const ButtonContainer = styled(ModalFooter)`
  style: flex;
  justify-content: end;
`;

const StyledModalBody = styled(ModalBody)(
  ({ theme }) => `
  display: block;
  width: ${theme.wideMeasure};
`,
);
